export default __webpack_public_path__ + "alberta-outpatient.80d0e6590e0620a98736.svg";